/**
 * Formats a file size in bytes to a human-readable string.
 * Automatically selects the appropriate unit (B, KB, MB) based on size.
 *
 * - Files < 1 KB: Shows in bytes (e.g., "512 B")
 * - Files < 1 MB: Shows in KB with no decimals (e.g., "256 KB")
 * - Files >= 1 MB: Shows in MB with 1 decimal place (e.g., "2.5 MB")
 *
 * @param bytes - The file size in bytes
 * @returns Formatted file size string
 *
 * @example
 * formatBytes(1024);        // "1 KB"
 * formatBytes(2048000);     // "2.0 MB"
 * formatBytes(512);         // "512 B"
 */
export function formatBytes(bytes: number): string {
  if (bytes === 0) return "0 B";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  if (bytes < 1024 * 1024 * 1024)
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
}
